import { render, staticRenderFns } from "./DriversTransfers.vue?vue&type=template&id=7c366da0&scoped=true"
import script from "./DriversTransfers.vue?vue&type=script&lang=js"
export * from "./DriversTransfers.vue?vue&type=script&lang=js"
import style0 from "./DriversTransfers.vue?vue&type=style&index=0&id=7c366da0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c366da0",
  null
  
)

export default component.exports